import React from "react";
import "./App.css";

import { About, Footer, Header, Skills, Testimonial, Work } from "./container";
import { Navbar, SocialPhone } from "./components";
function App() {


  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      {/* <Testimonial /> */}
      
      <Footer />

      <SocialPhone />

      
    </div>
  );
}

export default App;
